import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const SaveBackupCodesContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const SaveBackupCodesIcon = styled(Box)(() => ({
  marginBottom: "32px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const SaveBackupCodesTitle = styled(Typography)(() => ({
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: "16px",
  color: "#1B252F",
}));

export const SaveBackupCodesSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  marginBottom: "16px",
  maxWidth: "450px",
}));

export const SaveBackupCodes = styled(Box)(() => ({
  width: "100%",
  marginBottom: "44px",
}));
export const SaveBackupCodesList = styled(Box)(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  columnGap: "47px",
  rowGap: "4px",
  marginBottom: "16px",
}));

export const SaveBackupCodesCollapseAllContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  "& p": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontFamily: "Nunito",
    margin: 0,
    fontSize: "16px",
    fontWeight: 700,
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}));

export const SaveBackupCodesCollapse = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));

export const SaveBackupCodesCode = styled(Box)(() => ({
  fontFamily: "Nunito",
  fontSize: "18px",
  fontWeight: 700,
  wordBreak: "break-all",
  whiteSpace: "nowrap",
  lineHeight: "177%",
}));

export const SaveBackupCodesActions = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  gap: "16px",
  width: "100%",
}));
